<style lang="scss" scoped>
</style>

<template>
    <div id='survey-page-component'>
        <!-- SHOW SPINNER WHILE LOADING SURVEY -->
        <div v-show="isQuizLoading" class="text-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading Knowledge Quiz...</span>
            </div>
        </div>

        <!-- SHOW SURVEY -->
        <div v-show="!isQuizLoading">
            <slot name="surveyPageSlot">
                <survey-page ref="surveyPage"
                    :training-session="trainingSession"
                    :survey-type="surveyType"
                    :fetch-view="fetchView"
                    :refresh-view="refreshView"
                    :program="program"
                    :user="user"
                ></survey-page>
            </slot>

            <slot name="submitMsg"></slot>

            <!-- SUBMIT BUTTON -->
            <slot name="submitBtn">
                <button v-if="true" ref="submitBtn" id="nav-finalize" type="submit" name="nav" value="finalize" class="btn btn-orange-blue">Submit</button>
                <button v-else class="btn btn-orange-blue" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Loading...</span>
                </button>
            </slot>
        </div>
    </div>
</template>

<script>

    import SurveyPage from '../../components/SurveyPage.js';
    import { mapState } from 'vuex';

    export default {
        components: {
            SurveyPage,
        },
        props: {
            trainingSession: {
                type: Object
            },
            surveyType: {
                type: String,
            },
            program: {
                required: false,
                type: Object,
                default: () => {
                    return {};
                }
            },
            user: {
                required: false,
                type: Object,
                default: null
            },
            fetchView: {
                required: false,
                default: true
            },
            refreshView: {
                required: false,
                default: true
            }
        },
        computed: {
            ...mapState([
                'isQuizLoading',
            ]),
        },
    }
</script>
